export default __webpack_public_path__ + "static/media/about-us2.712222ab.jpeg";